<template>
  <div v-if="userId" class="profile">
    <div style="width: 100%;">
      <div>
        <div style="position: relative; margin: auto; width: 128px;">
          <el-avatar :size="128" :src="user.image_uri == null ? '/images/profile_placeholder.png' : user.image_uri"></el-avatar>
          <button v-if="user.o_id == user.o_id && !editing" @click="editing = true" class="profile-edit-button" >
            <i class="material-icons" style="margin: 8px; font-size: 18px;" >edit</i>
          </button>
        </div>
        <h4 class="profile-name">{{ user.rank.name + ' ' + user.firstName + ' ' + user.lastName }}</h4>
      </div>
      <div :style="{ height: windowHeight - 252 + 'px' }" style="overflow-y: scroll">
        <div v-if="!editing" style="margin: 0em 2em;">
          <p v-if="user.primary_position != null" class="profile-position">{{ user.primary_position.name }}</p>
          <div class="section-header">
            <div class="title">
              Info
            </div>
            <div class="divider"></div>
          </div>
          <div>
            <div v-if="user.level != null" class="flex">
              <span class="mgra sub-header">Class</span>
              <span>{{ user.level.name }}</span>
            </div>
            <div v-if="user.phone != null" class="flex">
              <span class="mgra sub-header">Phone</span>
              <span class="link"><a :href="'tel:' + user.phone">{{ formatPhoneNumber(user.phone) }}</a></span>
            </div>
            <div class="flex">
              <span class="mgra sub-header">E-mail</span>
              <span class="link"><a :href="'mailto:' + user.un + '@rit.edu'">{{ user.un + '@rit.edu' }}</a></span>
            </div>
            <div v-if="user.major != null" class="flex">
              <span class="mgra sub-header">Major</span>
              <span>{{ user.major }}</span>
            </div>
            <div v-if="user.school != null" class="flex">
              <span class="mgra sub-header">School</span>
              <span>{{ user.school }}</span>
            </div>
            <div v-if="user.hometown != null" class="flex">
              <span class="mgra sub-header">Hometown</span>
              <span>{{ user.hometown }}</span>
            </div>
          </div>
          <div v-loading="loadingBio">
            <div class="section-header">
              <div class="title">
                Biography
              </div>
              <div class="divider"></div>
            </div>
            <div class="profile-bio"><span v-html="bio" v-if="bio != null"></span></div>
          </div>
        </div>
        <div v-else v-loading="ranks == null" style="margin: 0em 2em;">
          <el-form label-position="left" label-width="100px" ref="form" :model="user">
            <el-form-item label="RIT UID">
              <el-input v-model="uid" type="password" placeholder="Hidden"></el-input>
            </el-form-item>
            <el-form-item v-if="ranks != null" label="Rank">
              <el-select v-model="old.rank" placeholder="Select your rank." value-key="o_id">
                <el-option v-for="rank in ranks" :key="rank.o_id" :label="rank.name" :value="rank"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="School">
              <el-input v-model="old.school"></el-input>
            </el-form-item>
            <el-form-item label="Major">
              <el-input v-model="old.major"></el-input>
            </el-form-item>
            <el-form-item label="Hometown">
              <el-input v-model="old.hometown"></el-input>
            </el-form-item>
            <el-form-item label="Phone">
              <el-input v-model="old.phone" type="tel" maxlength="10"></el-input>
            </el-form-item>
          </el-form>

          <hr/>
          <vue-editor v-model="oldBio" :editorOptions="editorOption"></vue-editor>
          <div style="display: flex; justify-content: space-between;">
              <el-button v-if="editing" @click="editing= false;" type="text">Cancel</el-button>
              <el-button v-if="editing" @click="saveUser" type="text" >Save</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {VueEditor} from 'vue2-editor'
import {mapFields} from 'vuex-map-fields';

export default {
    components: {VueEditor},
    props: ['userId'],
    data() {
        return {
            bio: null,
            loadingBio: true,
            oldBio: null,
            uid: null,
            old: null,
            editing: false,
            editorOption: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'link'],
                        [{'indent': '-1'}, {'indent': '+1'}],
                        [{list: 'ordered'}, {list: 'bullet'}]
                    ]
                },
                placeholder: 'Write about yourself here...'
            }
        };
    },
    computed: {
        ...mapFields([
            'user',
            'events',
            'users',
            'attendance',
            'selectedTerms',
            'ranks'
        ]),

        user() {
            return this.users[this.users.map((e) => {return e.o_id}).indexOf(this.userId)];
        },

        llabTotal(){
            var i = 0;
            var tempEvents = this.events.filter((event) => {
                if(this.selectedTerms.filter((term) => event.term == term).length == 0){
                    return false;
                }
                return event.event_type == 2;
            });
            var s = tempEvents.length;
            tempEvents.forEach((event) => {
                var x = this.attendance.find((att) => att.userId == this.user.o_id && att.event_id == event.o_id);
                if(x != null){
                    var t = x.attendance_type;
                    if(t == 1 || t == 3 || t == 4){
                        i++;
                    }
                }else{
                    i++;
                }
            });
            return Math.round(i/s * 100);
        },
        ptTotal() {
            var i = 0;
            var tempEvents = this.events.filter((event) => {
                if(this.selectedTerms.filter((term) => event.term == term).length == 0){
                    return false;
                }
                return event.event_type == 1;
            });
            var s = tempEvents.length;
            tempEvents.forEach((event) => {
                var x = this.attendance.find((att) => att.userId == this.user.o_id && att.event_id == event.o_id);
                if(x != null){
                    var t = x.attendance_type;
                    if(t == 1 || t == 3 || t == 4){
                        i++;
                    }
                }else{
                    i++;
                }

            });
            return Math.round(i/s * 100);
        }
    },
    mounted() {
        this.old = {
            'rank': this.user.rank,
            'school': this.user.school,
            'major': this.user.major,
            'hometown': this.user.hometown,
            'phone': this.user.phone
        };
        if(this.user != null){
            this.getBio();
        }
        if(this.terms == null)
            this.$store.dispatch('pullTerms');
        if(this.events == null)
            this.$store.dispatch('pullEvents');
        if(this.attendance == null)
            this.$store.dispatch('pullAttendance');
        if(this.users == null)
            this.$store.dispatch('pullUsers');
        if(this.ranks == null)
            this.$store.dispatch('pullRanks');
    },
    methods: {
        formatPhoneNumber(s) {
            var s2 = String(s).replace(/\D/g, '');
            var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
            return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
        },
        saveUser() {
            var body = {
                'rank': this.old.rank.o_id,
                'school': this.old.school,
                'major': this.old.major,
                'hometown': this.old.hometown,
                'phone': this.old.phone
            };
            if(this.uid != null){
                body.uid = this.uid;
            }
            this.axios.put('/api/v1/userbio/'+this.user.o_id,
                {'bio': this.oldBio},
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then(() => {
                this.bio = this.oldBio;
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if(err.response){
                    terr = err.response.data.errors;
                }
                this.$message({
                    message: terr,
                    type: 'error'
                });
            });
            this.axios.put('/api/v1/users/'+this.user.o_id,
                body,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.$set(this.users, this.users.map((e) => {return e.o_id}).indexOf(this.user.o_id), response.data);
                this.$store.state.user = response.data;
                this.editing = false;
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if(err.response){
                    terr = err.response.data.errors;
                }
                this.$message({
                    message: terr,
                    type: 'error'
                });
            });
        },
        closePanel() {
            this.$emit('closePanel', {name: this.name});
        },
        editProfile() {
            this.editing = true;
        },
        cancelEditing() {

            this.editing = false;
        },
        getBio() {
            this.loadingBio = true;
            this.axios.get('/api/v1/userbio/'+ this.user.o_id,
                {
                    headers: {'Content-Type': 'application/json'},
                    credentials: 'same-origin'
                }).then((response) => {
                this.bio = response.data.bio;
                this.oldBio = response.data.bio;
                this.loadingBio = false;
            }).catch((err) => {
                console.error(err);
                var terr = err;
                if(err.response){
                    terr = err.response.data.errors;
                }
                this.$message({
                    message: terr,
                    type: 'error'
                });
                this.loadingBio = false;
            });
            this.loading = false;
        }
    }
}
</script>
